
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "ABPOCAAA",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ABPOCAAA.vue